export async function streamItems(url, { headers } = {}, onItem, onError) {
  if (typeof fetch === 'function' && typeof ReadableStream !== 'undefined') {
    try {
      const res = await fetch(url, { headers });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buf = '';
      /*eslint no-constant-condition: "warn"*/
      // eslint-disable-next-line
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        let nl;
        while ((nl = buf.indexOf('\n')) >= 0) {
          const line = buf.slice(0, nl).trim();
          buf = buf.slice(nl + 1);
          if (!line) continue;
          try { onItem(JSON.parse(line)); } catch (err) { if (onError) onError(err, line); }
        }
      }
      if (buf.trim()) {
        try { onItem(JSON.parse(buf)); } catch (err) { if (onError) onError(err, buf); }
      }
      return;
    } catch (err) {
      if (onError) onError(err);
      // fallthrough to axios fetch as a fallback
    }
  }
   // Axios fallback (non-streaming; waits for full body)
  try {
    const resp = await this.$api.get(url, { headers });
    const text = typeof resp.data === 'string' ? resp.data : JSON.stringify(resp.data);
    const lines = text.split('\n').map(s => s.trim()).filter(Boolean);
    for (const line of lines) {
      try { onItem(JSON.parse(line)); } catch (err) { if (onError) onError(err, line); }
    }
  } catch (err) {
    if (onError) onError(err);
  }
}
